/* ==========================================================================
   MidasTime BR — Shapewear PDP JavaScript v3.0
   Self-contained: cart API, money formatting, gallery, variants, ATC,
   accordion, qty selector, before/after slider, size guide, share.
   ========================================================================== */

(function () {
  'use strict';

  /* --------------------------------------------------------------------------
     1. GLOBAL HELPERS (ShpPDP namespace)
     -------------------------------------------------------------------------- */
  var listeners = {};
  window.ShpPDP = window.ShpPDP || {};

  window.ShpPDP.on = function (event, cb) {
    if (!listeners[event]) listeners[event] = [];
    listeners[event].push(cb);
  };

  window.ShpPDP.emit = function (event, data) {
    if (listeners[event]) listeners[event].forEach(function (cb) { cb(data); });
  };

  window.ShpPDP.cart = {
    add: function (items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: Array.isArray(items) ? items : [items] })
      }).then(function (r) { return r.json(); })
        .then(function (d) { window.ShpPDP.emit('cart:updated'); return d; });
    }
  };

  window.ShpPDP.formatMoney = function (cents) {
    var value = parseInt(cents, 10) / 100;
    var parts = value.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$\u00a0' + parts.join(',');
  };

  /* --------------------------------------------------------------------------
     2. ACCORDION (delegated)
     -------------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.shp-product-page .accordion__trigger');
    if (!trigger) return;

    var item = trigger.closest('.accordion__item');
    if (!item) return;

    var isOpen = item.classList.contains('is-open');
    var accordion = item.closest('.accordion, .product-accordion');

    if (accordion && !accordion.hasAttribute('data-multi')) {
      var siblings = accordion.querySelectorAll('.accordion__item.is-open');
      siblings.forEach(function (s) {
        if (s !== item) {
          s.classList.remove('is-open');
          var sibTrigger = s.querySelector('.accordion__trigger');
          if (sibTrigger) sibTrigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    item.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
  });

  /* --------------------------------------------------------------------------
     3. QUANTITY SELECTOR (delegated)
     -------------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.shp-product-page .qty-selector__btn');
    if (!btn) return;

    var wrapper = btn.closest('.qty-selector');
    var input = wrapper.querySelector('.qty-selector__input');
    var current = parseInt(input.value, 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var max = parseInt(input.getAttribute('max'), 10) || 99;

    if (btn.hasAttribute('data-action-minus')) {
      input.value = Math.max(min, current - 1);
    } else if (btn.hasAttribute('data-action-plus')) {
      input.value = Math.min(max, current + 1);
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* --------------------------------------------------------------------------
     4. PRODUCT PAGE (gallery, variants, ATC, bundle, share)
     -------------------------------------------------------------------------- */
  function initAllSections() {
    var section = document.querySelector('[data-section-type="product"]');
    if (section) {
      initProductPage(section);
    }
    initBeforeAfter();
    initSizeGuide();
    initRecommendations();
    initProductCards();
    initShippingBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  function initProductPage(section) {
    var productJson = [];
    try {
      var jsonEl = section.querySelector('[data-product-variants]');
      if (jsonEl) productJson = JSON.parse(jsonEl.textContent);
    } catch (_) {}

    var variantIdInput = section.querySelector('[data-variant-id]');
    var addToCartBtn = section.querySelector('[data-add-to-cart]');
    var btnText = addToCartBtn ? addToCartBtn.querySelector('.btn__text') : null;

    /* aria-live on price for screen reader announcements */
    var priceContainer = section.querySelector('[data-product-price]');
    if (priceContainer) priceContainer.setAttribute('aria-live', 'polite');

    /* --- Gallery --- */
    var thumbs = section.querySelectorAll('[data-thumb-index]');
    var slides = section.querySelectorAll('[data-slide-index]');
    var dots = section.querySelectorAll('[data-dot-index]');
    var carousel = section.querySelector('[data-gallery-carousel]');
    var zoomEl = section.querySelector('[data-gallery-zoom]');

    function showSlide(index, scrollCarousel) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });

      if (scrollCarousel && carousel && window.innerWidth < 750) {
        var slide = carousel.children[index];
        if (slide) carousel.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showSlide(parseInt(thumb.getAttribute('data-thumb-index'), 10), true);
      });
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        showSlide(parseInt(dot.getAttribute('data-dot-index'), 10), true);
      });
    });

    if (carousel) {
      var scrollTimer;
      carousel.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var scrollLeft = carousel.scrollLeft;
          var slideWidth = carousel.offsetWidth;
          var index = Math.round(scrollLeft / slideWidth);
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
          thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
        }, 100);
      }, { passive: true });

      /* Keyboard navigation: ArrowLeft / ArrowRight */
      carousel.setAttribute('tabindex', '0');
      carousel.setAttribute('role', 'region');
      carousel.setAttribute('aria-label', 'Galeria de imagens do produto');
      carousel.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var currentIndex = 0;
          dots.forEach(function (d, i) { if (d.classList.contains('is-active')) currentIndex = i; });
          var nextIndex = e.key === 'ArrowRight'
            ? Math.min(currentIndex + 1, slides.length - 1)
            : Math.max(currentIndex - 1, 0);
          showSlide(nextIndex, true);
        }
      });
    }

    /* Zoom on hover (desktop with mouse only) */
    var mainEl = section.querySelector('[data-gallery-main]');
    var hasHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (mainEl && zoomEl && hasHover) {
      mainEl.addEventListener('mousemove', function (e) {
        var activeSlide = mainEl.querySelector('.product-gallery__slide.is-active img');
        if (!activeSlide) return;
        var zoomSrc = activeSlide.getAttribute('data-zoom-src');
        if (!zoomSrc) return;

        var rect = mainEl.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;

        zoomEl.style.backgroundImage = 'url(' + zoomSrc + ')';
        zoomEl.style.backgroundSize = '200%';
        zoomEl.style.backgroundPosition = x + '% ' + y + '%';
      });

      mainEl.addEventListener('mouseleave', function () {
        zoomEl.style.backgroundImage = '';
      });
    }

    /* --- Variant Selection --- */
    var optionBtns = section.querySelectorAll('[data-option-value-btn]');

    function getSelectedVariant() {
      var selectedOptions = [];
      section.querySelectorAll('.variant-selector').forEach(function (sel) {
        var active = sel.querySelector('[data-option-value-btn].is-active');
        if (active) selectedOptions.push(active.getAttribute('data-option-value-btn'));
      });

      for (var i = 0; i < productJson.length; i++) {
        var v = productJson[i];
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (v.options[j] !== selectedOptions[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function updateInlineBadge(variant) {
      var badge = section.querySelector('[data-inline-badge]');
      if (!variant || !variant.compare_at_price || variant.compare_at_price <= variant.price) {
        if (badge) badge.style.display = 'none';
        return;
      }
      var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
      var amt = window.ShpPDP.formatMoney(variant.compare_at_price - variant.price);
      var text = pct + '% OFF — Economize ' + amt;

      if (badge) {
        badge.textContent = text;
        badge.style.display = '';
      } else {
        var priceRow = section.querySelector('[data-product-price]');
        if (priceRow) {
          var span = document.createElement('span');
          span.className = 'badge badge--inline';
          span.setAttribute('data-inline-badge', '');
          span.textContent = text;
          priceRow.appendChild(span);
        }
      }
    }

    function updateBundleCard(variant) {
      var bundleCard = section.querySelector('[data-bundle-card]');
      if (!bundleCard || !variant) return;

      var qty = parseInt(bundleCard.getAttribute('data-bundle-qty'), 10);
      var discount = parseInt(bundleCard.getAttribute('data-bundle-discount'), 10);
      var originalTotal = variant.price * qty;
      var bundleTotal = Math.round(originalTotal * (100 - discount) / 100);
      var savings = originalTotal - bundleTotal;

      var originalEl = bundleCard.querySelector('[data-bundle-original]');
      var finalEl = bundleCard.querySelector('[data-bundle-final]');
      var savingsEl = bundleCard.querySelector('[data-bundle-savings]');

      if (originalEl) originalEl.textContent = window.ShpPDP.formatMoney(originalTotal);
      if (finalEl) finalEl.textContent = window.ShpPDP.formatMoney(bundleTotal);
      if (savingsEl) savingsEl.textContent = 'Economize ' + window.ShpPDP.formatMoney(savings);
    }

    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var parent = btn.closest('.variant-selector');
        var siblings = parent.querySelectorAll('[data-option-value-btn]');
        siblings.forEach(function (s) {
          s.classList.remove('is-active');
          if (s.hasAttribute('aria-checked')) s.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-active');
        if (btn.hasAttribute('aria-checked')) btn.setAttribute('aria-checked', 'true');

        var label = parent.querySelector('[data-option-value]');
        if (label) label.textContent = btn.getAttribute('data-option-value-btn');

        var matchedVariant = getSelectedVariant();

        if (matchedVariant) {
          variantIdInput.value = matchedVariant.id;

          var url = new URL(window.location.href);
          url.searchParams.set('variant', matchedVariant.id);
          window.history.replaceState({}, '', url.toString());

          if (matchedVariant.available) {
            addToCartBtn.disabled = false;
            if (btnText) btnText.textContent = 'Adicionar ao carrinho';
          } else {
            addToCartBtn.disabled = true;
            if (btnText) btnText.textContent = 'Esgotado';
          }

          var priceContainer = section.querySelector('[data-product-price]');
          if (priceContainer) {
            var priceHtml = '';
            if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
              priceHtml += '<span class="price__original">' + window.ShpPDP.formatMoney(matchedVariant.compare_at_price) + '</span>';
              priceHtml += '<span class="price__sale">' + window.ShpPDP.formatMoney(matchedVariant.price) + '</span>';
            } else {
              priceHtml += '<span class="price__regular">' + window.ShpPDP.formatMoney(matchedVariant.price) + '</span>';
            }
            priceContainer.innerHTML = '<div class="price">' + priceHtml + '</div>';
          }

          updateInlineBadge(matchedVariant);
          updateBundleCard(matchedVariant);

          if (matchedVariant.featured_image) {
            var targetSrc = matchedVariant.featured_image.src;
            slides.forEach(function (slide, idx) {
              var img = slide.querySelector('img');
              if (img && img.src.indexOf(targetSrc.split('?')[0].split('/').pop()) !== -1) {
                showSlide(idx);
              }
            });
          }
        }
      });
    });

    /* --- Bundle card click --- */
    var bundleCard = section.querySelector('[data-bundle-card]');
    if (bundleCard) {
      bundleCard.addEventListener('click', function () {
        var qty = parseInt(bundleCard.getAttribute('data-bundle-qty'), 10);
        var qtyInput = section.querySelector('.qty-selector__input');
        if (qtyInput) {
          qtyInput.value = qty;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        bundleCard.classList.toggle('is-active');
      });
    }

    /* --- Add to cart --- */
    var form = section.querySelector('[data-product-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addToCartBtn.disabled) return;

        addToCartBtn.setAttribute('aria-busy', 'true');
        addToCartBtn.setAttribute('aria-label', 'Adicionando ao carrinho...');
        addToCartBtn.disabled = true;

        var formData = new FormData(form);
        var items = {
          id: parseInt(formData.get('id'), 10),
          quantity: parseInt(formData.get('quantity'), 10) || 1
        };

        window.ShpPDP.cart.add(items)
          .then(function () {
            if (btnText) btnText.textContent = 'Adicionado!';
            addToCartBtn.setAttribute('aria-label', 'Adicionado com sucesso');
            setTimeout(function () {
              if (btnText) btnText.textContent = 'Adicionar ao carrinho';
              addToCartBtn.removeAttribute('aria-busy');
              addToCartBtn.removeAttribute('aria-label');
              addToCartBtn.disabled = false;
            }, 2000);
          })
          .catch(function () {
            addToCartBtn.removeAttribute('aria-busy');
            addToCartBtn.removeAttribute('aria-label');
            addToCartBtn.disabled = false;
          });
      });
    }

    /* --- Share button --- */
    var shareBtn = section.querySelector('[data-share-btn]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        if (navigator.share) {
          navigator.share({ title: document.title, url: window.location.href });
        } else {
          navigator.clipboard.writeText(window.location.href).then(function () {
            shareBtn.setAttribute('title', 'Link copiado!');
          });
        }
      });
    }
  }

  /* --------------------------------------------------------------------------
     5. BEFORE / AFTER SLIDER
     -------------------------------------------------------------------------- */
  function initBeforeAfter() {
    document.querySelectorAll('[data-before-after]').forEach(function (card) {
      if (card.__baInit) return;
      card.__baInit = true;

      var afterImg = card.querySelector('[data-after-image]');
      var handle = card.querySelector('[data-handle]');
      if (!afterImg || !handle) return;

      var dragging = false;

      function setPosition(x) {
        var rect = card.getBoundingClientRect();
        var percent = Math.max(0, Math.min(100, ((x - rect.left) / rect.width) * 100));
        afterImg.style.clipPath = 'inset(0 ' + (100 - percent) + '% 0 0)';
        handle.style.left = percent + '%';
      }

      card.addEventListener('mousedown', function (e) { dragging = true; setPosition(e.clientX); });
      card.addEventListener('touchstart', function (e) { dragging = true; setPosition(e.touches[0].clientX); }, { passive: true });

      document.addEventListener('mousemove', function (e) { if (dragging) setPosition(e.clientX); });
      document.addEventListener('touchmove', function (e) { if (dragging) setPosition(e.touches[0].clientX); }, { passive: true });

      document.addEventListener('mouseup', function () { dragging = false; });
      document.addEventListener('touchend', function () { dragging = false; });

      /* Keyboard support for before/after slider */
      handle.setAttribute('tabindex', '0');
      handle.setAttribute('role', 'slider');
      handle.setAttribute('aria-label', 'Comparação antes e depois');
      handle.setAttribute('aria-valuemin', '0');
      handle.setAttribute('aria-valuemax', '100');
      handle.setAttribute('aria-valuenow', '50');
      handle.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var current = parseInt(handle.getAttribute('aria-valuenow'), 10);
        var step = e.key === 'ArrowRight' ? 2 : -2;
        var next = Math.max(0, Math.min(100, current + step));
        handle.setAttribute('aria-valuenow', String(next));
        afterImg.style.clipPath = 'inset(0 ' + (100 - next) + '% 0 0)';
        handle.style.left = next + '%';
      });
    });
  }

  /* --------------------------------------------------------------------------
     6. SIZE GUIDE MODAL
     -------------------------------------------------------------------------- */
  function initSizeGuide() {
    var sizeModal = document.getElementById('shp-size-guide-modal');
    if (!sizeModal || sizeModal.__sgInit) return;
    sizeModal.__sgInit = true;

    var lastTrigger = null;

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-size-guide-toggle]');
      if (toggle) {
        e.preventDefault();
        lastTrigger = toggle;
        sizeModal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        /* Focus first focusable element inside modal */
        var firstFocusable = sizeModal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (firstFocusable) firstFocusable.focus();
      }
      if (e.target.closest('[data-size-guide-close]')) {
        sizeModal.classList.remove('is-open');
        document.body.style.overflow = '';
        if (lastTrigger) lastTrigger.focus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sizeModal.classList.contains('is-open')) {
        sizeModal.classList.remove('is-open');
        document.body.style.overflow = '';
        if (lastTrigger) lastTrigger.focus();
      }

      /* Focus trap: Tab cycles within modal */
      if (e.key === 'Tab' && sizeModal.classList.contains('is-open')) {
        var focusable = sizeModal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (focusable.length === 0) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }
    });
  }

  /* --------------------------------------------------------------------------
     7. PRODUCT RECOMMENDATIONS (Section Rendering API)
     -------------------------------------------------------------------------- */
  function initRecommendations() {
    var recoSection = document.querySelector('[data-recommendations-section]');
    if (!recoSection) return;

    var productId = recoSection.getAttribute('data-product-id');
    var sectionId = recoSection.getAttribute('data-section-id');
    var limit = recoSection.getAttribute('data-limit') || 4;

    if (productId && sectionId) {
      var recoUrl = '/recommendations/products?product_id=' + productId + '&limit=' + limit + '&section_id=' + sectionId;

      fetch(recoUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var newSection = temp.querySelector('[data-recommendations-section]');
          if (newSection && newSection.innerHTML.trim().length > 0) {
            recoSection.outerHTML = newSection.outerHTML;
          }
        })
        .catch(function () {});
    }
  }

  /* --------------------------------------------------------------------------
     8. PRODUCT CARD QUICK ADD (delegated)
     -------------------------------------------------------------------------- */
  function initProductCards() {
    if (window.__shpCardInit) return;
    window.__shpCardInit = true;

    function getVariants(card) {
      var el = card.querySelector('[data-quick-variants]');
      if (!el) return [];
      try { return JSON.parse(el.textContent); } catch (_) { return []; }
    }

    function findVariant(variants, colorIdx, colorVal, sizeIdx, sizeVal) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (colorIdx !== null && v.options[colorIdx] !== colorVal) continue;
        if (sizeIdx !== null && v.options[sizeIdx] !== sizeVal) continue;
        return v;
      }
      return null;
    }

    function updateSizeButtons(modal, variants, colorIdx, colorVal, sizeIdx) {
      if (sizeIdx === null) return;
      modal.querySelectorAll('[data-quick-modal-size]').forEach(function (btn) {
        var sizeVal = btn.getAttribute('data-size-value');
        var variant = findVariant(variants, colorIdx, colorVal, sizeIdx, sizeVal);
        var avail = variant && variant.available;
        btn.classList.toggle('quick-add-modal__size--unavailable', !avail);
        btn.disabled = !avail;
      });
    }

    function quickAddToCart(btn, variantId, modal) {
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      window.ShpPDP.cart.add({ id: variantId, quantity: 1 })
        .then(function () {
          if (modal) modal.hidden = true;
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
        })
        .catch(function () {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
        });
    }

    /* Direct quick add */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;

      window.ShpPDP.cart.add({ id: parseInt(variantId, 10), quantity: 1 })
        .then(function () {
          btn.textContent = 'Adicionado!';
          setTimeout(function () {
            btn.textContent = 'Adicionar ao carrinho';
            btn.removeAttribute('aria-busy');
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
        });
    });

    /* Open quick add modal */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add-modal]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var card = btn.closest('[data-product-card]');
      if (!card) return;

      document.querySelectorAll('.quick-add-modal:not([hidden])').forEach(function (m) {
        m.hidden = true;
      });

      var modal = card.querySelector('[data-quick-modal]');
      if (!modal) return;

      modal.querySelectorAll('.is-selected').forEach(function (s) { s.classList.remove('is-selected'); });

      var hasSize = modal.getAttribute('data-has-size') === 'true';
      var sizeIdx = modal.hasAttribute('data-size-index') ? parseInt(modal.getAttribute('data-size-index'), 10) : null;
      var hasColor = modal.getAttribute('data-has-color') === 'true';

      if (hasColor && hasSize) {
        modal.querySelectorAll('[data-quick-modal-size]').forEach(function (b) {
          b.disabled = true;
          b.classList.add('quick-add-modal__size--unavailable');
        });
      } else if (hasSize && !hasColor) {
        var variants = getVariants(card);
        updateSizeButtons(modal, variants, null, null, sizeIdx);
      }

      modal.hidden = false;
    });

    /* Select color in modal */
    document.addEventListener('click', function (e) {
      var colorBtn = e.target.closest('[data-quick-modal-color]');
      if (!colorBtn) return;
      e.preventDefault();
      e.stopPropagation();

      var modal = colorBtn.closest('[data-quick-modal]');
      if (!modal) return;
      var card = modal.closest('[data-product-card]');
      if (!card) return;

      modal.querySelectorAll('[data-quick-modal-color]').forEach(function (b) { b.classList.remove('is-selected'); });
      colorBtn.classList.add('is-selected');

      var colorVal = colorBtn.getAttribute('data-quick-modal-color');
      var colorIdx = modal.hasAttribute('data-color-index') ? parseInt(modal.getAttribute('data-color-index'), 10) : null;
      var hasSize = modal.getAttribute('data-has-size') === 'true';
      var sizeIdx = modal.hasAttribute('data-size-index') ? parseInt(modal.getAttribute('data-size-index'), 10) : null;
      var variants = getVariants(card);

      if (hasSize) {
        updateSizeButtons(modal, variants, colorIdx, colorVal, sizeIdx);
      } else {
        var variant = findVariant(variants, colorIdx, colorVal, null, null);
        if (variant) quickAddToCart(colorBtn, variant.id, modal);
      }
    });

    /* Select size in modal */
    document.addEventListener('click', function (e) {
      var sizeBtn = e.target.closest('[data-quick-modal-size]');
      if (!sizeBtn || sizeBtn.disabled) return;
      e.preventDefault();
      e.stopPropagation();

      var modal = sizeBtn.closest('[data-quick-modal]');
      if (!modal) return;
      var card = modal.closest('[data-product-card]');
      if (!card) return;

      var sizeIdx = modal.hasAttribute('data-size-index') ? parseInt(modal.getAttribute('data-size-index'), 10) : null;
      var colorIdx = modal.hasAttribute('data-color-index') ? parseInt(modal.getAttribute('data-color-index'), 10) : null;
      var sizeVal = sizeBtn.getAttribute('data-size-value');
      var variants = getVariants(card);

      var colorVal = null;
      var hasColor = modal.getAttribute('data-has-color') === 'true';
      if (hasColor) {
        var selectedColor = modal.querySelector('[data-quick-modal-color].is-selected');
        if (!selectedColor) return;
        colorVal = selectedColor.getAttribute('data-quick-modal-color');
      }

      var variant = findVariant(variants, colorIdx, colorVal, sizeIdx, sizeVal);
      if (variant && variant.available) {
        quickAddToCart(sizeBtn, variant.id, modal);
      }
    });

    /* Close modal on outside click */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-quick-modal]') || e.target.closest('[data-quick-add-modal]')) return;
      document.querySelectorAll('.quick-add-modal:not([hidden])').forEach(function (m) {
        m.hidden = true;
      });
    });
  }

  /* --------------------------------------------------------------------------
     9. SHIPPING BADGE (geo-based delivery estimate)
     -------------------------------------------------------------------------- */
  function initShippingBadge() {
    var datesEl = document.getElementById('shippingDates');
    var locationEl = document.getElementById('shippingLocation');
    if (!datesEl) return;

    var holidays = new Set([
      '2025-03-03','2025-03-04','2025-04-18','2025-04-21','2025-05-01',
      '2025-06-19','2025-09-07','2025-10-12','2025-11-02','2025-11-15',
      '2025-12-25','2026-01-01','2026-02-16','2026-02-17','2026-04-03',
      '2026-04-21','2026-05-01','2026-06-04','2026-09-07','2026-10-12',
      '2026-11-02','2026-11-15','2026-12-25'
    ]);

    var sudesteSul = new Set(['SP','RJ','MG','ES','PR','SC','RS']);
    var months = ['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];

    function addBusinessDays(start, days) {
      var d = new Date(start);
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6 && !holidays.has(d.toISOString().slice(0,10))) added++;
      }
      return d;
    }

    function fmt(d) {
      return String(d.getDate()).padStart(2,'0') + ' de ' + months[d.getMonth()];
    }

    function renderDates(min, max) {
      var now = new Date();
      datesEl.textContent = 'Chega entre ' + fmt(addBusinessDays(now, min)) + ' e ' + fmt(addBusinessDays(now, max));
    }

    renderDates(6, 10);

    fetch('https://geo.midastime.com.br/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.city && data.state) {
          if (locationEl) locationEl.textContent = data.city + ', ' + data.state;
          if (sudesteSul.has(data.state)) {
            renderDates(3, 5);
          } else {
            renderDates(6, 10);
          }
        }
      })
      .catch(function () {});
  }

})();
